<template>
    <div>
    <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group id="form-group-id" :label="$t('scheduled_tasks.id')">
            <b-form-input :readonly="true" id="input-id" v-model="form.scheduledTaskId"></b-form-input>
        </b-form-group>
        <b-form-group id="form-group-description" :label="$t('scheduled_tasks.description')"> 
            <b-form-input :disabled="disabled" id="input-description" v-model="form.description" ></b-form-input>
        </b-form-group>
        <b-form-group id="form-group-enabled" :label="$t('scheduled_tasks.enabled')"> 
            <b-form-checkbox :disabled="disabled" id="checkbox-enabled" v-model="form.enabled" value="true" unchecked-value="false" />
        </b-form-group>
         <b-form-group id="form-group-tasktype" :label="$t('scheduled_tasks.task_type')" > 
            <ScheduledTaskTypeSelect :disabled="disabled" v-model="form.taskType" />
        </b-form-group>
        
        <!-- Olisikohan nämä mahdollista toteuttaa esim. "component"-tagilla ja "is"-propertyllä?
            Mitenhän käsiteltäisiin esim. oletustapaus, kun taskia ja tyyppiä ei ole vielä valittuna? -->
        <DisplayModeChangeSettings v-if="form.taskType == 'Display_Mode_Change'" v-model="form.taskParameters" />
        
        <b-form-group id="form-group-scheduletype" :label="$t('scheduled_tasks.schedule_type')" > 
            <ScheduleTypeSelect :disabled="disabled" v-model="form.scheduleType" />
        </b-form-group>

        <SpecificTimeScheduleSettings v-if="form.scheduleType == 'Specific_Time_Schedule'" v-model="form.scheduleParameters" />

       <b-container fluid>
        <b-row>
            <b-col >
                    <b-button type="submit" class="btn-primary" :disabled="disabled">{{ $t('button.submit') }}</b-button>
                    <b-button type="reset" class="btn-secondary" :disabled="resetDisabled">{{ $t('button.reset') }}</b-button>
            </b-col>
            <b-col cols="2">
                    <b-button class="btn btn-danger float-right" :disabled="deleteDisabled" @click="onDeleteTask">{{ $t('button.delete') }}</b-button>
            </b-col>
        </b-row>
       </b-container>
    </b-form>
    
    <b-modal id="modal-delete" static @ok="onDeleteOK" :title='deleteModalTitle'>
        {{ $t("scheduled_tasks.delete.prompt_message") }}
    </b-modal>
    
    <b-toaster name="paahdin" class="b-toaster-top-right"></b-toaster>

    </div>
    
</template>

<script>
import scheduledTask from '@/store/system/scheduledTask'
import ScheduledTaskTypeSelect from '@/components/System/ScheduledTasks/ScheduledTaskTypeSelect'
import ScheduleTypeSelect from '@/components/System/ScheduledTasks/ScheduleTypeSelect'
import DisplayModeChangeSettings from '@/components/System/ScheduledTasks/TaskSettings/DisplayModeChangeSettings'
import SpecificTimeScheduleSettings from '@/components/System/ScheduledTasks/ScheduleSettings/SpecificTimeScheduleSettings'

export default {
    name: 'ScheduledTaskEditForm',
    components: {
        ScheduledTaskTypeSelect,
        ScheduleTypeSelect,
        DisplayModeChangeSettings,
        SpecificTimeScheduleSettings
    },
    data: function() {
        return  {
            disabled: true,
            defaultFormData: {
                'scheduledTaskId': null,
                'description': null,
                'enabled': false, 
                'taskType': null,
                'taskParameters': {},
                'scheduleType': null,
                'scheduleParameters': {}
            },
            form: {
                'scheduledTaskId': null,
                'description': null,
                'enabled': false, 
                'taskType': null,
                'taskParameters': {},
                'scheduleType': null,
                'scheduleParameters': {}
            },
            modal: false
        }
    },
    created: function() {
        if (!this.$store.state.scheduledTask) {
             this.$store.registerModule("scheduledTask", scheduledTask);
        }
        this.$store.dispatch('scheduledTask/getTaskTypeList');
        this.$store.dispatch('scheduledTask/getScheduleTypeList');
    },
    watch: { 
        selectedTask() {
            var selection = this.$store.state.scheduledTask.selectedTask;
            if (selection != null) {
                this.form = Object.assign({}, selection);
            } else {
                this.form = this.defaultFormData;
            }
            if (this.form.scheduledTaskId != null) {
                this.disabled = false;
            }
        }
    },
    computed: {
        selectedTask() {
            return this.$store.state.scheduledTask.selectedTask;
        },
        taskTypeOptions() {
            return this.$store.state.scheduledTask.taskTypeList;
        },
        scheduleTypeOptions() {
            return this.$store.state.scheduledTask.scheduleTypeList;
        },
        deleteDisabled() {
            return this.form.scheduledTaskId == null;
        },
        resetDisabled() {
            return this.form.scheduledTaskId == null;
        },
        deleteModalTitle() {
            return this.$t("scheduled_tasks.delete.prompt_title");
        }
    },
    methods: {
        newTask() {   
            this.form = Object.assign({}, this.defaultFormData);
            this.disabled = false; 
        },
        onDeleteTask() {
            this.$bvModal.show('modal-delete')
        },
        onDeleteOK() {
            this.$store.dispatch('scheduledTask/deleteTask', this.form.scheduledTaskId).then(() => {
                this.$bvToast.toast(this.$t("notify.deleted"), {
                    title: this.$t('notify.notice'),
                    variant: 'success',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            }, () => {
                this.$bvToast.toast(this.$t("notify.deleting_failed"), {
                    title: this.$t('notify.notice'),
                    variant: 'danger',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            })
                .catch()
                .then(() => {
                    this.disabled = true;
                })
        },
        onSubmit(event) {
            event.preventDefault();
            //console.log(this.form.taskParameters.display);
            //console.log(this.form.taskParameters.displayMode);
            this.$bvToast.toast(this.$t("notify.saving"), {
                title: this.$t('notify.notice'),
                variant: 'success',
                autoHideDelay: 2000,
                toaster: 'paahdin'
            });
            this.$store.dispatch('scheduledTask/saveTask', this.form).then(() => {
                this.$bvToast.toast(this.$t("notify.saved"), {
                    title: this.$t('notify.notice'),
                    variant: 'success',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            }, () => {
                this.$bvToast.toast(this.$t("notify.saving_failed"), {
                    title: this.$t('notify.notice'),
                    variant: 'danger',
                    autoHideDelay: 2000,
                    toaster: 'paahdin'
                })
            })
                .catch()
                .then(() => {
                    this.disabled = true;
                });
        },
        onReset(event) {
            event.preventDefault(); 
            var selection = this.$store.state.scheduledTask.selectedTask;
            this.form = Object.assign({}, selection);
        }
    }
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0.1rem;
}
p .listNameParag {
  margin-bottom: 0.1rem;
}
.listNameText {
  font-weight: bold;
}
.listLabelText {
  font-style: italic;
  padding-left: 1em;
}
b-toaster {
    background-color:blue;
}
</style>